import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 


const firebaseConfig = {
  apiKey: "AIzaSyA3Msgn9N5TAmmMGFaQgD5pCJYS1gnzLd4",
  authDomain: "avukatemreuygun.firebaseapp.com",
  projectId: "avukatemreuygun",
  storageBucket: "avukatemreuygun.firebasestorage.app",
  messagingSenderId: "1064152175513",
  appId: "1:1064152175513:web:f69cba94be43f7a80ab908",
  measurementId: "G-EN02X1NJ79"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 